@if ((user$ | async) === null) {
  <div>
    <div class="w-screen h-screen flex justify-center items-center">
      <mat-progress-spinner
        mode="indeterminate"
        [strokeWidth]="5"
        [diameter]="100"
      ></mat-progress-spinner>
    </div>
  </div>
} @else {
  <div class="app-container" [class.min-w-[1100px]]="isMinWidth$ | async">
    <rk-header class="hidden md:block"></rk-header>
    <div class="flex content-container">
      <div class="main-content h-full w-full">
        @if (isCreationProcess$ | async) {
          <router-outlet></router-outlet>
        } @else {
          <rk-main-container>
            <div class="w-full h-full">
              <router-outlet></router-outlet>
            </div>
          </rk-main-container>
        }
      </div>
    </div>
  </div>
  <div class="lg:hidden h-full">
    <rk-mobile-access-warning></rk-mobile-access-warning>
  </div>
}

<rk-update-available></rk-update-available>
